module.exports = __webpack_public_path__ + "static/img/img_form_2_zh.de676571.png";